import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import { withActionByRole } from '../../../common/helpers/actions';
import { getShop } from '../../../auth/selectors';
import withToggle from '../../../common/hoc/withToggle';
import withFetchDataLoader from '../../../common/hoc/withFetchDataLoader';
import { fetchShopActiveRegister, fetchBarberActiveRegister } from '../actions';
import CashRegister from '../components/CashRegister';
import {
  hasActiveRegister,
  getRegisterTransactions,
  getActiveRegisterCurrentBalance,
  getActiveRegisterStartBalance,
} from '../selectors';

const mapStateToProps = state => ({
  shopId: getShop(state),
  hasActiveRegister: hasActiveRegister(state),
  currentBalance: getActiveRegisterCurrentBalance(state),
  startBalance: getActiveRegisterStartBalance(state),
  transactions: getRegisterTransactions(state),
});

export default compose(
  withRouter,
  withActionByRole('fetchData', fetchShopActiveRegister, fetchBarberActiveRegister),
  connect(mapStateToProps),
  withToggle('payout'),
  withFetchDataLoader,
)(CashRegister);
